import { autoinject, BindingEngine, computedFrom, customElement } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { TransferUserRolesModel } from 'model/forms/transfer-user-roles-model';
import { LookupsService } from 'services/lookups-service';
import { ModelBase } from 'support/base_classes/model-base';

@autoinject
@customElement('transfer-user-roles-form')
export class TransferUserRolesFormCustomElement extends ModelBase<TransferUserRolesModel> {

  constructor(private lookups: LookupsService, bindingEngine: BindingEngine) {
    super(bindingEngine);
  }

  modelChanged(newValue: TransferUserRolesModel) {
    super.modelChanged(newValue);
    if (this.model != null) {
      ValidationRules
        .ensureObject<TransferUserRolesModel>().required()
        .ensure(model => model.transferTo).displayName('Transfer to').required()
        .satisfies((value, model) => model.countriesApprove.some(x => x.checked) || model.countriesContact.some(x => x.checked) || model.delegateApprovers.some(x => x.checked)).withMessage('Please select at least one role.')
        .on(this.model);
    }
  }

  usersLookupOptions = this.lookups.getUsersLookupOptions();

  @computedFrom('model.transferTo')
  get userGroupLabel() {
    return this.model?.transferTo != null ?
      [`role: ${this.model.transferTo.jobTitle ?? ''}`, `bp email: ${this.model.transferTo.mail ?? ''}`, `countries email: ${this.model.transferTo.countriesContactEmail ?? ''}`, `phone: ${this.model.transferTo.phone ?? ''}`].filter(l => l != null && l !== '')
      : 'Transfer to';
  }
}
